<template>
  <div>
    <div v-if="!isTransaksiLoyalty">
      <div class="f-bold f-16 f-c-black m-d-16">
        Pengaturan Transaksi
      </div>
      <div v-if="(transaksi.parfum??'') !== ''" class="d-flex-between-center m-d-8">
        <div class="f-regular f-16 f-c-midgrey">
          Parfum
        </div>
        <div class="f-regular f-16 f-c-black">
          {{ transaksi.parfum }}
        </div>
      </div>
      <div class="separator-line m-t-8 m-d-12"></div>
      <div>
        <span class="f-regular f-14 f-c-midgrey m-d-4">Keterangan</span>
        <p class="f-regular f-14">{{ transaksi.keterangan }}</p>
      </div>
      <SOImageList :images="showImages"/>
      <div>
        <p class="f-regular f-14 f-c-midgrey m-d-16 m-t-20">Dokumentasi Pengambilan</p>
        <div v-if="FotoPengambilan.length>0" class="d-flex overflow-auto" style="gap: 12px">
          <template v-for="(foto, index) in FotoPengambilan">
            <img
                v-if="foto.ref_table === 'transaksi_ambil'"
                :key="index"
                class="img-view"
                :src="'https://storage.googleapis.com/' + foto.cloud_bucket + '/' + (foto.cloud_thumb || foto.cloud_name)"
                alt=""
                @click="openImage('https://storage.googleapis.com/' + foto.cloud_bucket + '/' + foto.cloud_name, foto.cloud_content_type)"
            >
          </template>
        </div>
      </div>
    </div>
    <!--  whitelabel start-->
	<template v-if="isTransaksiLoyalty">
		<div class="p-t-16 p-d-16" v-if="transaksi.is_jemput">
		  <div class="f-bold f-16 f-c-black">
			Penjemputan
		  </div>
		  <div class="d-flex-between-center m-t-16">
			<div class="f-regular f-16 f-c-midgrey">
			  Metode
			</div>
			<div class="f-regular f-16 f-c-black">
			  <!-- {{ transaksi.jadwal_jemput.nama_kurir }} -->
			  {{ courierMethod.find(v => v.value === transaksi.jadwal_jemput.jenis_kurir).title }}
			</div>
		  </div>
		  <div class="d-flex-between-center m-t-8">
			<div class="f-regular f-16 f-c-midgrey">
			  Jadwal
			</div>
			<div class="f-regular f-16 f-c-black">
				{{ $moment(transaksi.jadwal_jemput.waktu_raw).utc().format("dddd, DD MMM YYYY HH:mm") }}
			</div>
		  </div>
		  <div class="m-t-8">
			<div class="f-regular f-16 f-c-midgrey">
			  Alamat Penjemputan
			</div>
			<div class="separator-line m-t-8 m-d-12"></div>
			<div class="f-regular f-14 f-c-black">
			  {{ transaksi.jadwal_jemput.alamat }}
			</div>
		  </div>
		</div>
		<div class="p-t-16 p-d-16">
		  <div class="f-bold f-16 f-c-black">
			Pengantaran
		  </div>
		  <div class="d-flex-between-center m-t-16">
			<div class="f-regular f-16 f-c-midgrey">
			  Metode
			</div>
			<div class="f-regular f-16 f-c-black">
				{{ courierMethod.find(v => v.value === transaksi.pengantaran_extra.courier_type).title }}
			</div>
		  </div>
		  <div class="d-flex-between-center m-t-8">
			<div class="f-regular f-16 f-c-midgrey">
			  Jadwal
			</div>
			<div class="f-regular f-16 f-c-black">
				{{ transaksi.pengantaran.tanggal_antar ? $moment(transaksi.pengantaran.tanggal_antar).format("dddd, DD MMM YYYY HH:mm") : '-' }}
			</div>
		  </div>
		  <div class="m-t-8">
			<div class="f-regular f-16 f-c-midgrey">
			  Alamat Pengantaran
			</div>
			<div class="separator-line m-t-8 m-d-12"></div>
			<div class="f-regular f-14 f-c-black">
			  {{ transaksi.pengantaran.alamat || '-' }}
			</div>
		  </div>
		</div>
		<!-- whitelabel start-->
		<SOImagePreview
			:modalId="'modalImagePreview-' + transaksi.idtransaksi"
			ref="img"
		/>
	</template>
  </div>
</template>
<script>
import SOImagePreview from '@/so-components/global/ui/SOImagePreview.vue';
import { courierMethod } from "@/store/utils/vars";
import SOImageList from '@/so-components/global/ui/SOImageList.vue';

export default {
  name: 'PengaturanTransaksi',
  components: {
    SOImagePreview,
    SOImageList,
  },
  data() {
    return {
      image: {
        show: false,
        url: null
      },
	  courierMethod: courierMethod,
    }
  },
  props: {
    transaksi: Object
  },
  computed: {
    showImages() {
      return this.transaksi.transaksi_foto
    },
    FotoPengambilan() {
      return this.transaksi.bukti_ambil_foto
    },
    isTransaksiLoyalty() {
      return this.transaksi.transaksi_loyalty
    }
  },
  methods: {
    openImage(imgUrl, contentType) {
      this.$refs.img.open(imgUrl, contentType)
    },
    isTransaksi() {
      let show = this.transaksi.transaksi_foto.ref_table
      console.log(show)
      return show
    },
  }
}
</script>
<style scoped>
#container > div {
  padding-left: 16px;
  padding-right: 16px;
}

.img-view {
  min-width: 80px;
  min-height: 80px;
  width: 80px;
  height: 80px;
  border: 1px solid #E1E5EC;
  box-sizing: border-box;
  border-radius: 3px;
  object-fit: cover;
}
</style>